// import React, { createContext, useState, useContext, useEffect } from "react";
// import { useZone } from "./ZoneContext";

// const FilterContext = createContext();

// export const FilterProvider = ({ children }) => {
//   const { units } = useZone();
//   const [filters, setFilters] = useState({
//     bedrooms: { min: "", max: "" },
//     bathrooms: { min: "", max: "" },
//     area: { min: "", max: "" },
//     availabilityHiddenIds: [],
//   });
//   const [searchText, setSearchText] = useState("");

//   useEffect(() => {
//     if (units.length === 0) return;

//     const maxValues = {
//       bedrooms: Math.max(...units.map((u) => u.num_of_bedrooms)),
//       bathrooms: Math.max(...units.map((u) => u.num_of_bathrooms)),
//       area: Math.max(...units.map((u) => Number(u.built_up_area))),
//     };

//     setFilters((prev) => ({
//       bedrooms: {
//         min: prev.bedrooms.min || "",
//         max: prev.bedrooms.max || maxValues.bedrooms,
//       },
//       bathrooms: {
//         min: prev.bathrooms.min || "",
//         max: prev.bathrooms.max || maxValues.bathrooms,
//       },
//       area: { min: prev.area.min || "", max: prev.area.max || maxValues.area },
//       availabilityHiddenIds: prev.availabilityHiddenIds,
//     }));
//   }, [units]);

//   const [availabilitySource, setAvailabilitySource] = useState("svg");
//   const [availabilityHiddenIdsSvg, setAvailabilityHiddenIdsSvg] = useState([]);
//   const [availabilityHiddenIdsSearch, setAvailabilityHiddenIdsSearch] =
//     useState([]);
//   const filteredUnits = units.filter((unit) => {
//     const bedroomMin =
//       filters.bedrooms.min !== "" ? Number(filters.bedrooms.min) : null;
//     const bedroomMax =
//       filters.bedrooms.max !== "" ? Number(filters.bedrooms.max) : null;

//     const bathroomMin =
//       filters.bathrooms.min !== "" ? Number(filters.bathrooms.min) : null;
//     const bathroomMax =
//       filters.bathrooms.max !== "" ? Number(filters.bathrooms.max) : null;

//     const areaMin = filters.area.min !== "" ? Number(filters.area.min) : null;
//     const areaMax = filters.area.max !== "" ? Number(filters.area.max) : null;

//     if (bedroomMin !== null && unit.num_of_bedrooms < bedroomMin) return false;
//     if (bedroomMax !== null && unit.num_of_bedrooms > bedroomMax) return false;

//     if (bathroomMin !== null && unit.num_of_bathrooms < bathroomMin)
//       return false;
//     if (bathroomMax !== null && unit.num_of_bathrooms > bathroomMax)
//       return false;

//     if (areaMin !== null && Number(unit.built_up_area) < areaMin) return false;
//     if (areaMax !== null && Number(unit.built_up_area) > areaMax) return false;

//     // availability (search / svg)
//     if (availabilityHiddenIdsSearch.includes(unit.availability?.id))
//       return false;
//     if (searchText.trim() !== "") {
//       const q = searchText.toLowerCase().trim();

//       // 1. تقسيم الكود بناءً على علامة "-"
//       const codeParts = unit.code ? unit.code.split("-") : [];

//       // 2. الحصول على آخر جزء (رقم الفيلا)
//       const villaNumber =
//         codeParts.length > 0
//           ? codeParts[codeParts.length - 1].toLowerCase()
//           : "";

//       // 3. التحقق إذا كان رقم الفيلا يبدأ أو يحتوي على النص المكتوب
//       if (!villaNumber.includes(q)) {
//         return false;
//       }
//     }
//     return true;
//   });

//   return (
//     <FilterContext.Provider
//       value={{
//         filters,
//         setFilters,
//         filteredUnits,
//         availabilitySource,
//         setAvailabilitySource,
//         availabilityHiddenIdsSearch,
//         setAvailabilityHiddenIdsSearch,
//         availabilityHiddenIdsSvg,
//         setAvailabilityHiddenIdsSvg,
//         searchText,
//         setSearchText,
//         units,
//       }}
//     >
//       {children}
//     </FilterContext.Provider>
//   );
// };

// export const useFilterContext = () => useContext(FilterContext);







import React, { createContext, useState, useContext, useEffect } from "react";
import { useZone } from "./ZoneContext";
import { useTabsFilter } from "./TabsFilterContext";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const { units } = useZone();
  const { bookingDate, activeTab } = useTabsFilter();

  const [filters, setFilters] = useState({
    bedrooms: { min: "", max: "" },
    bathrooms: { min: "", max: "" },
    area: { min: "", max: "" },
    availabilityHiddenIds: [],
  });

  const [searchText, setSearchText] = useState("");
  const [availabilitySource, setAvailabilitySource] = useState("svg");
  const [availabilityHiddenIdsSvg, setAvailabilityHiddenIdsSvg] = useState([]);
  const [availabilityHiddenIdsSearch, setAvailabilityHiddenIdsSearch] = useState([]);

  useEffect(() => {
    if (units.length === 0) return;

    const maxValues = {
      bedrooms: Math.max(...units.map((u) => u.num_of_bedrooms || 0)),
      bathrooms: Math.max(...units.map((u) => u.num_of_bathrooms || 0)),
      area: Math.max(...units.map((u) => Number(u.built_up_area || 0))),
    };

    setFilters((prev) => ({
      ...prev,
      bedrooms: { min: prev.bedrooms.min || "", max: prev.bedrooms.max || maxValues.bedrooms },
      bathrooms: { min: prev.bathrooms.min || "", max: prev.bathrooms.max || maxValues.bathrooms },
      area: { min: prev.area.min || "", max: prev.area.max || maxValues.area },
    }));
  }, [units]);

  const filteredUnits = units.filter((unit) => {
    // --- 1. فلاتر الخصائص (غرف، حمامات، مساحة) ---
    const bedroomMin = filters.bedrooms.min !== "" ? Number(filters.bedrooms.min) : null;
    const bedroomMax = filters.bedrooms.max !== "" ? Number(filters.bedrooms.max) : null;
    const bathroomMin = filters.bathrooms.min !== "" ? Number(filters.bathrooms.min) : null;
    const bathroomMax = filters.bathrooms.max !== "" ? Number(filters.bathrooms.max) : null;
    const areaMin = filters.area.min !== "" ? Number(filters.area.min) : null;
    const areaMax = filters.area.max !== "" ? Number(filters.area.max) : null;

    if (bedroomMin !== null && unit.num_of_bedrooms < bedroomMin) return false;
    if (bedroomMax !== null && unit.num_of_bedrooms > bedroomMax) return false;
    if (bathroomMin !== null && unit.num_of_bathrooms < bathroomMin) return false;
    if (bathroomMax !== null && unit.num_of_bathrooms > bathroomMax) return false;
    if (areaMin !== null && Number(unit.built_up_area) < areaMin) return false;
    if (areaMax !== null && Number(unit.built_up_area) > areaMax) return false;

    // --- 2. منطق Booking Date الدقيق 🔥 ---
    if (activeTab === "bookingDate") {
      const rawUnitDate = unit.booking_date;

      if (!bookingDate || bookingDate === "") {
        // الوضع الافتراضي: إظهار المحجوز فقط (الذي يمتلك تاريخ)
        if (!rawUnitDate) return false;
      } else {
        if (!rawUnitDate) return false;

        // فك النص المرسول (بداية ونهاية)
        const [startRangeStr, endRangeStr] = bookingDate.split(",");
        
        const startDateRange = new Date(startRangeStr);
        const endDateRange = new Date(endRangeStr);
        const unitDate = new Date(rawUnitDate);

        // تصفير الساعات لضمان دقة المقارنة بالأيام فقط
        startDateRange.setHours(0, 0, 0, 0);
        endDateRange.setHours(0, 0, 0, 0);
        unitDate.setHours(0, 0, 0, 0);

        // الشرط: هل تاريخ الفيلا يقع داخل النطاق؟
        const isInRange = unitDate >= startDateRange && unitDate <= endDateRange;

        if (!isInRange) return false;
      }
    }

    // --- 3. فلاتر التوفر (Search / Svg) ---
    if (availabilityHiddenIdsSearch.includes(unit.availability?.id)) return false;

    // --- 4. البحث النصي (رقم الفيلا من الكود) ---
    if (searchText.trim() !== "") {
      const q = searchText.toLowerCase().trim();
      const codeParts = unit.code ? unit.code.split("-") : [];
      const villaNumber = codeParts.length > 0 ? codeParts[codeParts.length - 1].toLowerCase() : "";
      if (!villaNumber.includes(q)) return false;
    }

    return true;
  });

  return (
    <FilterContext.Provider
      value={{
        filters,
        setFilters,
        filteredUnits,
        availabilitySource,
        setAvailabilitySource,
        availabilityHiddenIdsSearch,
        setAvailabilityHiddenIdsSearch,
        availabilityHiddenIdsSvg,
        setAvailabilityHiddenIdsSvg,
        searchText,
        setSearchText,
        units,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => useContext(FilterContext);